import {_} from 'lodash';
import * as ko from "knockout";

import {getNextId} from "../util/misc";

type TValidator = () => boolean

export interface IValidatorBase {
    fn: TValidator
    message: (() => string) | string
    prerequisite?: () => boolean // prerequisite must be fulfilled for validation to execute
}

interface IValidator extends IValidatorBase {
    id: number
}

export class ErrorObject {
    private validators: KnockoutObservableArray<IValidator> = ko.observableArray<IValidator>([]);
    public readonly id: number
    public readonly name: string;
    private latestErrorMessage: KnockoutObservable<string | null> = ko.observable(null);

    constructor(params?: { name: string }) {
        this.id = getNextId();
        this.name = params?.name ?? `error.object.${this.id}`;
        this.init();
    }

    public init() {
        this.validators([]);
    }

    public addValidator(...arr: IValidatorBase[]): number {
        let id = 0;
        arr.forEach(obj => {
            id = getNextId();
            this.validators.push(_.defaults({id: id}, obj));
        })
        return id
    }

    public validate = ko.pureComputed((): boolean => {
        return this.validators().reduce((valid: boolean, obj: IValidator) => {
            if (obj.prerequisite && !obj.prerequisite()) {
                return valid;
            }
            return obj.fn() && valid;
        }, true);
    }).extend({throttle: 1});

    public getErrorMessage = ko.pureComputed((): string => {
        const message = this.validators().find((obj: IValidator) => {
            if (obj.prerequisite && !obj.prerequisite()) {
                return false;
            }
            return !obj.fn();
        })?.message ?? null;
        let ret: string | null = null
        if (typeof message === 'function') {
            ret = message()
        } else {
            ret = message
        }
        if (ret) {
            this.latestErrorMessage(ret);
        }
        return ret ?? ''
    });

    dispose() {
        this.validate.dispose()
        this.getErrorMessage.dispose()
    }
}